import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  "aria-label": "Volg brand"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-323.000000, -118.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "331.56 118 331.55 123.36 337 123.36 337 126.47 331.55 126.47 331.56 132 328.44 132 328.44 126.47 323 126.47 323 123.36 328.44 123.36 328.44 118"
})))));